import React from "react";
import cursorIcon from "../../assets/about/cursorIcon.png";
import gameIcon from "../../assets/about/gameIcon.png";
import aboutImage from "../../assets/about/perfilImage.png";
import serverIcon from "../../assets/about/serverIcon.png";
import styles from "./About.module.css";

export const About = () => {
  return (
    <section className={styles.container} id="about">
      <h2 className={styles.title}>About</h2>
      <div className={styles.content}>
        <img
          src={aboutImage}
          alt="Me sitting with a laptop"
          className={styles.aboutImage}
        />
        <ul className={styles.aboutItems}>
          <li className={styles.aboutItem}>
            <img src={cursorIcon} alt="Cursor icon" className={styles.icon} />
            <div className={styles.aboutItemText}>
              <h3>Passionate Creator</h3>
              <p>
              As a Software Developer I’m dedicated to crafting interactive experiences through games and web applications.
              </p>
            </div>
          </li>
          <li className={styles.aboutItem}>
            <img src={serverIcon} alt="Server icon" className={styles.icon} />
            <div className={styles.aboutItemText}>
              <h3>Lifelong Learner</h3>
              <p>
              I thrive on learning and enjoy experimenting with new technologies to bring my ideas to life.
              </p>
            </div>
          </li>
          <li className={styles.aboutItem}>
            <img src={gameIcon} alt="UI icon" className={styles.icon} />
            <div className={styles.aboutItemText}>
              <h3>Community Advocate</h3>
              <p>
              Fueled by my love for video games and music to support women in game development and inspire others to pursue their passions.
              </p>
            </div>
          </li>
        </ul>
      </div>
    </section>
  );
};